import waitForChangeAndMutate from '@utils/user/waitForChangeAndMutate'

const waitForPartnerPacketChangeAndMutate = (props) =>
    waitForChangeAndMutate({ ...props, query: 'prepaid_items' })

export default waitForPartnerPacketChangeAndMutate